import { Component, OnInit, Renderer2 } from '@angular/core';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { catchError, interval, of, Subscription } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { CycleCountResponse } from 'src/app/wings-mobile/models/cycle-count/cycle-count-response';
import { CycleCountSaveRequest } from 'src/app/wings-mobile/models/cycle-count/cycle-count-save-request';
import { CycleCountZoneResponse } from 'src/app/wings-mobile/models/cycle-count/cycle-count-zone-response';
import { AuditCycleCount } from 'src/app/wings-mobile/services/auditCycleCount/auditCycleCount.service';
import { MessageBeep } from 'src/app/wings-mobile/services/messageBeep/messageBeep.service';
import { Globals } from '../../../shared/globals/globals';
import { NgIf, NgStyle, NgClass, AsyncPipe, UpperCasePipe } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonDirective } from 'primeng/button';
import { InputGenericComponent } from '../../../shared/input-generic/input-generic.component';

@Component({
    selector: 'audit',
    templateUrl: './audit.component.html',
    styleUrls: ['./audit.component.scss'],
    imports: [NgIf, NgStyle, SelectModule, FormsModule, InputTextModule, NgClass, ButtonDirective, InputGenericComponent, AsyncPipe, UpperCasePipe, TranslatePipe]
})
export class AuditComponent implements OnInit {

	auditResponse: CycleCountResponse[];

	quantityPartsSaved: CycleCountResponse[] = [];

	saveIsOk: boolean = true;

	countType = CycleCountTypeEnum;

	subscription: Subscription;

	returnedZones$: Observable<CycleCountZoneResponse[]>;
	returnedZonesError$: Observable<CycleCountZoneResponse[]>;

	loading: boolean = true;
	skipButtonDisable: boolean = true;

	itemScreen = 1;
	itemList = 0;

	selectedZone: CycleCountZoneResponse;
	currentZoneName: string;

	inputFields = [
		{ name: 'label_location', id: 'label_location', focus: false, value: null, action: 'this.checkLocation()', valid: false },
		{ name: 'label_quantity', id: 'label_quantity', focus: false, value: null, action: 'this.validQuantity()', valid: false }
	];

	constructor(
		private beep: MessageBeep,
		public translate: TranslateService,
		public globals: Globals,
		private auditCycleCount: AuditCycleCount,
		private renderer: Renderer2,
	) {
		this.globals = globals;
		this.auditCycleCount = auditCycleCount;
		this.beep = beep;
		this.translate = translate;
		this.renderer = renderer;
	}

	ngOnInit(): void {
		this.loadZones();
	}

	loadZones() {
		let newObservable = interval(10);
		this.subscription = newObservable.subscribe(() => {
			if (this.globals.user.warehouse.bkSubDivisionUidD && this.globals.user.warehouse.warehouseUidK) {
				this.subscription.unsubscribe();
				this.returnedZones$ = this.auditCycleCount.getZonesWithPartsToBeCounted(['A']).pipe(
					catchError(error => {
						this.beep.showAlertCustom('modal.error', this.translate.instant('modal.infoRequestNotValid'));
						return of();
					})
				);
			}
		})
	}

	checkDropdownValid() {
		this.inputFields[0].value = null;
		this.inputFields[1].value = null;
		this.inputFields[0].valid = false;
		this.inputFields[1].valid = false;
		this.saveIsOk = true;
		this.itemScreen = 1;
		this.itemList = 0;
		if (this.selectedZone && this.selectedZone !== undefined) {
			this.currentZoneName = undefined;
			this.auditCycleCount.getPartToCount(this.selectedZone.zoneC, ['A'])
				.subscribe({
					next: res => {
						if (res.length !== 0) {
							this.auditResponse = res;
							this.skipButtonDisable = false;
							this.auditResponse.forEach(item => {
								if (item.description === undefined || item.description === null) {
									item.description = "";
								}
							})
							this.currentZoneName = this.selectedZone.zoneC;
							this.focusInputFields('label_location', true)
						} else {
							this.resetOnErrorLabelCycleCount(this.translate.instant('modal.noPiecesToCounted'))
						}
					},
					error: error => {
						if (typeof error.error !== 'string') {
							this.resetOnErrorLabelCycleCount(this.translate.instant('modal.connectionFailed'));
						} else {
							this.resetOnErrorLabelCycleCount(this.translate.instant(error.error));
						}
					}
				})
		}
	}

	checkLocation() {
		this.inputFields[0].value = this.inputFields[0].value.toUpperCase();
		this.chackNameLocation(0);
		if (this.inputFields[0].value === this.auditResponse[this.itemList].location || this.inputFields[0].value === "999999") {
			this.inputFields[0].valid = true;
			setTimeout(() => this.renderer.selectRootElement(`#label_quantity`).focus(), 100);

		} else {
			this.inputFields[0].value = null;
			this.inputFields[0].focus = false;
			this.beep.showAlertCustom('modal.error', this.translate.instant('modal.incorrectLocation'));
		}
	}

	validQuantity() {
		if (this.inputFields[0].value && this.inputFields[1].value !== null) {
			this.inputFields[1].valid = true;
		}
	}

	skipCountingPart() {
		if (this.itemScreen <= this.auditResponse.length) {
			this.itemScreen++;
			this.itemList++;
			this.inputFields[0].value = null;
			this.inputFields[1].value = null;
			this.inputFields[0].valid = false;
			this.inputFields[1].valid = false;
		}
		if (this.itemScreen > this.auditResponse.length) {
			this.auditResponse = this.auditResponse.filter((part) => {
				return this.quantityPartsSaved.indexOf(part) == -1
			});
			this.itemScreen = 1;
			this.itemList = 0;
			if (this.auditResponse.length === 0) {
				this.screenReset();
				this.validQuantity();
				this.loadZones();
			}
		}
	}

	saveRequestGenerator(): CycleCountSaveRequest {
		let request: CycleCountSaveRequest = new CycleCountSaveRequest();
		request.cycleCountTypeC = "A";
		request.partCodeGspnPreffix = this.auditResponse[this.itemList].partCodeGspnPreffix;
		request.partCodeGspnBase = this.auditResponse[this.itemList].partCodeGspnBase;
		request.partCodeGspnSuffix = this.auditResponse[this.itemList].partCodeGspnSuffix;
		request.cycleCountHistoryUidK = this.auditResponse[this.itemList].cycleCountHistoryUid;
		request.count = this.inputFields[1].value;
		request.countOperatorC = this.globals.user.userName;
		request.partXWarehouseUidK = this.auditResponse[this.itemList].partXWarehouseUidK;

		return request;
	}

	saveCountingPart() {
		this.auditCycleCount.save(this.saveRequestGenerator()).subscribe({
			next: res => {
				if (!res) {
					this.quantityPartsSaved.push(this.auditResponse[this.itemList]);
					this.skipCountingPart();
				}
				if (res.errors) {
					if (res.errors[0].errorCode === 20 || res.errors[0].errorCode === 10) {
						this.currentZoneName = undefined;
						this.resetOnErrorLabelCycleCount(this.translate.instant('modal.typeLocation'));
					} else if (res.errors[0].errorCode === 30) {
						this.currentZoneName = undefined;
						this.resetOnErrorLabelCycleCount(this.translate.instant('modal.lowerQuantity'));
					} else {
						this.currentZoneName = undefined;
						this.resetOnErrorLabelCycleCount(this.translate.instant('modal.unableToSave'));
					}
				}
			},
			error: error => {
				if (typeof error.error !== 'string') {
					this.resetOnErrorLabelCycleCount(this.translate.instant('modal.connectionFailed'))
				} else {
					this.resetOnErrorLabelCycleCount(this.translate.instant(error.error))
				}
			}
		})
	}

	resetOnErrorLabelCycleCount(errorMsg: string) {
		this.screenReset();
		this.beep.showAlertCustom('modal.error', errorMsg);
	}

	screenReset() {
		this.skipButtonDisable = true;
		this.auditResponse = null;
		this.inputFields[0].value = null;
		this.inputFields[1].value = null;
		this.inputFields[0].valid = false;
		this.inputFields[1].valid = false;
		this.selectedZone = undefined;
	}

	focusInputFields(elId: string = 'remove', focusZebra: boolean = false) {

		if (focusZebra) {
			this.renderer.selectRootElement('#scanner_id').focus();
			this.inputFields[0].focus = true;
		} else {
			if (elId !== 'remove') {
				this.renderer.selectRootElement(`#${elId}`).focus();
			} else {
				this.inputFields[0].focus = false
			}
		}
	}

	checkInputs() {
		let disable = false;
		this.inputFields.forEach(item => {
			if (!item.valid) {
				disable = true;
			}
		});
		return disable;
	}

	executeAction(item) {
		eval(item.action);
	}

	resetQtd() {
		this.inputFields[0].valid = false;
		this.inputFields[1].value = null;
	}

	chackNameLocation(position: number) {
		this.inputFields[position].value = this.inputFields[position].value.replaceAll(' ', '');
		this.inputFields[position].value = this.inputFields[position].value.replaceAll('*', '');
	}
}

export enum CycleCountTypeEnum {
	RECOUNT = "R",
	AUDIT = "A",
	COUNT = "C"
}

